/* @flow */
import React from 'react';

import styles from './styles.module.scss';

type Props = {
  orientation?: 'horizontal' | 'vertical',
};

const Divider = ({ orientation = 'horizontal' }: Props): React$Element<any> => {
  return (
    <hr
      className={orientation === 'vertical' ? styles.dividerVertical : styles.dividerHorizontal}
    />
  );
};

export default Divider;
